import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateWording } from '../../store/actions';
import CartMain from '../../components/Cart/cart.main';
import LayoutPreload from '../../components/Preload/layout.preload';

export default function CartPage() {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const isFetching = useSelector(({ cart }) => cart.isFetching);

    useEffect(() => {
        dispatch(updateWording());
    }, [dispatch, currentLanguage]);

    if (isFetching) return <LayoutPreload />;
    return <CartMain />;
}
